import CatalogMemberMixin, { getName } from "../../../../../ModelMixins/CatalogMemberMixin";
import DiscretelyTimeVaryingMixin from "../../../../../ModelMixins/DiscretelyTimeVaryingMixin";
import MappableMixin from "../../../../../ModelMixins/MappableMixin";
import SelectableDimensions, { DEFAULT_PLACEMENT, filterSelectableDimensions, findSelectedValueName, isGroup } from "../../../../../Models/SelectableDimensions/SelectableDimensions";
import Legend from "../../../../Workbench/Controls/Legend";
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const renderDisplayVariables = catalogItem => {
  if (SelectableDimensions.is(catalogItem)) {
    return filterSelectableDimensions(DEFAULT_PLACEMENT)(catalogItem.selectableDimensions).map((dim, key) => !isGroup(dim) ? /*#__PURE__*/_jsxs("div", {
      children: [dim.name, ": ", findSelectedValueName(dim)]
    }, key) : null);
  }
  return null;
};
const renderLegend = catalogItem => {
  if (!MappableMixin.isMixedInto(catalogItem)) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    className: "layer-legends",
    children: [/*#__PURE__*/_jsx("div", {
      className: "layer-title",
      children: getName(catalogItem)
    }), DiscretelyTimeVaryingMixin.isMixedInto(catalogItem) && /*#__PURE__*/_jsxs("div", {
      className: "layer-time",
      children: ["Time: ", catalogItem.currentTime]
    }), CatalogMemberMixin.isMixedInto(catalogItem) && /*#__PURE__*/_jsx(Legend, {
      forPrint: true,
      item: catalogItem
    })]
  }, catalogItem.uniqueId);
};
const WorkbenchItem = _ref => {
  let {
    item
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: "WorkbenchItem",
    children: [/*#__PURE__*/_jsx("h3", {
      children: getName(item)
    }), renderDisplayVariables(item), /*#__PURE__*/_jsx("div", {
      children: renderLegend(item)
    })]
  });
};
const PrintWorkbench = props => {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: props.workbench.items.map((item, index) => /*#__PURE__*/_jsx(WorkbenchItem, {
      item: item
    }, index))
  });
};
export default PrintWorkbench;